// extracted by mini-css-extract-plugin
export default {"root":"veryrgIbAt","itemsContainer":"aKAHvcfCxq"};